import { createContext, useContext, useState } from "react";
import api from "../api/api";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(() => localStorage.getItem("username") || null);

  // LOGIN
  const login = async (username, password) => {
    const res = await api.post("token/", { username, password });
    const access = res.data.access;

    localStorage.setItem("token", access);
    localStorage.setItem("username", username);

    setToken(access);
    setUser(username);

    api.defaults.headers.Authorization = `Bearer ${access}`;
  };

  // LOGOUT
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    setToken(null);
    setUser(null);
    delete api.defaults.headers.Authorization;
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used inside AuthProvider");
  return context;
}
